/**
 * Heading and subheading for arm C (`form_first_ad_match`) of the challenge
 * page A/B/C test (Rob, 2026-10-02).
 *
 * These strings mirror, word for word, the top Google Ads text in the Proven
 * campaign as of 2026-10-02 (Google Ads scoreboard, last 14 days):
 * - heading: the top headline by far, "AI Trading for Beginners".
 * - subheading: the top long headline.
 *
 * When Proven's winning headline or long headline changes, update these two
 * strings to match. The default is stable. Ad URLs can supply an approved pair below; arbitrary
 * URL text never becomes marketing copy.
 */
export const CHALLENGE_AD_MATCH_COPY = {
  heading: 'AI Trading for Beginners',
  subheading: 'Free 7-day AI trading challenge. Watch Claude research a real stock live.',
} as const;

export type ChallengeAdMatchCopy = { heading: string; subheading: string };

// Verified enabled Main PMax asset group 6750066488, 2026-10-04. These are
// selected ad messages, not a claim that PMax exposes its exact shown headline.
const APPROVED_AD_MESSAGES: readonly ChallengeAdMatchCopy[] = [
  CHALLENGE_AD_MATCH_COPY,
  {
    heading: 'AI Trades Real Money Daily',
    subheading:
      'AI that trades your real money every day. Learn how in a free live class with Rob.',
  },
];

export function resolveChallengeAdMatchCopy(search: string): ChallengeAdMatchCopy {
  const params = new URLSearchParams(search);
  return (
    APPROVED_AD_MESSAGES.find(
      (copy) =>
        copy.heading === params.get('challenge_headline') &&
        copy.subheading === params.get('challenge_subheadline'),
    ) || CHALLENGE_AD_MATCH_COPY
  );
}
